import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// core components
import Sidebar from "components/Sidebar/Sidebar.js";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import InstrumentEdit from 'views/Instrument/Edit.js';
import InstrumentIndex from 'views/Instrument/Index.js';
import CriteriaEdit from 'views/Criteria//Edit.js';
import ScheduleEdit from 'views/Schedule/Edit.js';
import AuditShow from 'views/Audit/Show.js';
import AnswerActionEdit from 'views/AnswerAction/Admin/Edit.js';


import AuditeeForm from 'views/Auditee/Form.js';
import AuditorForm from 'views/Auditor/Form.js';

import ProofForm from 'views/Form/Proof/Admin.js';
import EvaluationForm from 'views/Form/Evaluation/Admin.js';
import VisitationForm from 'views/Form/Visitation/Admin.js';

// dinamically create dashboard routes
import adminRoutes from "routes/manager.js";

import Monitoring from 'views/Audit/Admin/Monitoring.js';

import image1 from "assets/img/full-screen-image-1.jpg";
import image2 from "assets/img/full-screen-image-2.jpg";
import image3 from "assets/img/full-screen-image-3.jpg";
import image4 from "assets/img/full-screen-image-4.jpg";

function ManagerLayout() {

  const [sidebarImage, setSidebarImage] = React.useState(image3);
  const [sidebarBackground, setSidebarBackground] = React.useState("orange");

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/manager") {
        return (
          <Route
            exact
            path={prop.layout + prop.path}
            key={key}
            component={prop.component}
          />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <div className="wrapper">
      <Sidebar
        layout={`manager`}
        routes={adminRoutes}
        image={sidebarImage}
        background={sidebarBackground}
      />
      <div className="main-panel">
        <AdminNavbar />
        <div className="content">
          <Switch>

            <Route exact path="/manager/auditee/create" component={AuditeeForm}/>
            <Route exact path="/manager/auditee/:auditeeId" component={AuditeeForm}/>
            <Route exact path="/manager/auditor/create" component={AuditorForm}/>
            <Route exact path="/manager/auditor/:auditorId" component={AuditorForm}/>

            <Route exact path="/manager/instruments/:instrumentId/criterias/:criteriaId/edit" component={CriteriaEdit}/>
            <Route exact path="/manager/instruments/:instrumentId/edit" component={InstrumentEdit}/>
            <Route exact path="/manager/instruments" component={InstrumentIndex}/>

            <Route exact path="/manager/proofs/:formId" component={ProofForm}/>
            <Route exact path="/manager/evaluations/:formId" component={EvaluationForm}/>
            <Route exact path="/manager/visitations/:formId" component={VisitationForm}/>

            <Route exact path="/manager/schedules/:scheduleId/edit" component={ScheduleEdit}/>
            <Route exact path="/manager/actions/:actionId/edit" component={AnswerActionEdit} />
            <Route path="/manager/audits/:scheduleId" component={AuditShow}/>
            <Route path="/manager/monitorings" component={Monitoring}/>

            {getRoutes(adminRoutes)}
            <Redirect to="/auth/404" />
          </Switch>
        </div>
        <AdminFooter />
        <div
          className="close-layer"
          onClick={() =>
            document.documentElement.classList.toggle("nav-open")
          }
        />
      </div>
    </div>
  );
}

export default ManagerLayout;
